import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createVNode as _createVNode, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "row justify-center items-center"
}

import { PropType, computed, ref, defineComponent } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectOrComponent',
  props: {
  modelValue: {
    type: String,
    default: '',
  },
  options: {
    type: Array as PropType<string[]>,
    required: true,
  },
  otherComponent: {
    type: String,
    default: 'q-input',
  },
  defaultValueForOther: {
    type: String,
    default: 'Otro',
  },
},
  emits: ["update:modelValue"],
  setup(__props, { emit }: { emit: ({
  (event: 'update:modelValue', value: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props;

defineComponent({
  inheritAttrs: false,
});





const optionsLocal = computed(() => {
  const newOptions = [...props.options];
  newOptions.push('Otro');
  return newOptions;
});

const rValue = computed({
  get: () => props.modelValue,
  set: (value) => {
    if (value === 'Otro') {
      showOtherComponent.value = true;
      emit('update:modelValue', props.defaultValueForOther);
      return;
    }
    emit('update:modelValue', value);
  },
});

const showOtherComponent = ref(false);
if (!!rValue.value) {
  if (!optionsLocal.value.includes(rValue.value)) {
    showOtherComponent.value = true;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createBlock(_Transition, {
    mode: "out-in",
    "enter-active-class": "animated fadeIn",
    "leave-active-class": "animated fadeOut"
  }, {
    default: _withCtx(() => [
      (!showOtherComponent.value)
        ? (_openBlock(), _createBlock(_component_q_select, _mergeProps({
            key: 0,
            modelValue: _unref(rValue),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(rValue) ? (rValue).value = $event : null)),
            options: _unref(optionsLocal)
          }, _ctx.$attrs), null, 16, ["modelValue", "options"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(props.otherComponent), _mergeProps({
              modelValue: _unref(rValue),
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(rValue) ? (rValue).value = $event : null)),
              class: "col"
            }, _ctx.$attrs), null, 16, ["modelValue"])),
            _createVNode(_component_q_btn, {
              icon: "arrow_back",
              padding: "none",
              class: "tw-h-[50%] col-auto",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (showOtherComponent.value = false)),
              dense: "",
              flat: ""
            })
          ]))
    ]),
    _: 1
  }))
}
}

})